// src/documents/generateNotlar.js
// Default "Notlar" dokümanı içeriği — kullanıcı tarafından oluşturulan
// "Notlar-Elektrik-1" şablonundan baked in olarak alındı.
// Layout'ta active notlar template yoksa bu içerik kullanılır.

const Scl = 1;

const DEFAULT_TITLE = 'NOTLAR:';

const DEFAULT_NOTES = [
  "Yapılan tesisat , ELEKTRİK İÇ TESİSAT YÖNETMELİĞİ'ne ve ilgili standarlara uygun olacaktır.",
  "Kullanılan tüm malzemeler TSE 'ye uygun olacaktır.",
  "Aksi belirtilmedikçe aydınlatma panoları üzt kenarı bitmiş döşemeden 180 cm yükseklikte olacaktır.",
  "Aksi belirtilmedikçe tüm anahtarlar bitmiş döşeme kotundan 110 cm ve prizler 50 cm yükseklite olacaktır.",
  "Kapı kenarına konan anahtar ve prizler , düşeyde  aynı hizada olacak ve ekseni kapı kenarından 20 cm mesafede olacaktır.",
  "Buvat yükseklikleri tavandan 20 cm mesafede olacaktır.",
  "Tüm prizler kasalara vida ile tutturulacaktır.",
  "Kablolamada Fazlar Siyah veKahverengi, Nötr Hattı Mavi ve Toprak hattı ise Sarı-Yeşil olacaktır.",
  "Aksi belirtilmedikçe tüm linyeler ve priz hatları  2.5 mm² , Aydınlatma sortileri 1.5 mm² ile yapılacaktır.",
  "Tüm prizler ve aydınlatma tesisatı toprak hatlı olacaktır.",
  "Tüm Kablolar ve borular yalnız yatay döşenecektir.",
  "Bir buvata dört kablodan fazla giriş yapılmayacaktır, zorunlu olan yerlerde kare buvat kullanılacaktır.",
  "Sığınak , kazan dairesi, ana pano pano odasında tesisat sıva üstü olarak düşünülecektir. Sıva üstü kablolamada   düşeyde   her  50 cm'de yatayda her 30 cm'de bir kroşelenecektir.",
  "Sıva altı tesisata 10 ATÜ-PVC  kablo borusu kullanılacak ve boru çapı yürürlükte  bulunan ELEKTRİK İÇ TESİSAT YÖNETMELİĞ' ne uygun seçilecektir.",
  "Üç dirsekten sonra her 25 m 'yi geçen kablo borularında Kablo Çekme Borusu konuklacaktır.",
  "PVC Kablo boruları kalıp üzerine döşenirken , altına pas payı konulacaktır.",
  "Asma tavan içinden çekilecek kablolar NYM tipinde  olacaktır.",
  "Anahtarlar üste basıldığı zaman yanacak alta basıldığı zaman sönecektir.",
  "Fayans üzerine gelen priz ve anahtarlar fayansın tam ortasına getirilecektir.",
  "Beton elemanlara rastlayan kat tabloları için rezervasyon bırakılacaktır.",
  "Ana dağıtım panosu imalat resimleri için Kontrolluk onayı alınmadan imalata başlanmayacaktır.",
  "Aydınlatma linye sigortaları en az 3 kA , priz linye sigortaları en az 6 kA , tablo girişleri ve kolon sigortaları en az 10 kA kısa devre kesme akımı kapasitesinde  olacaktır.",
  "Tüm pano ve tablo kapak iç taraflarına tek hat şeması konulacak , cep yapılacaktır.",
  "Çevre aydınlatma için ilgili paftaya bakınız.",
  "Bilgisayar odası kapı altına iki adet ɸ 32 boru bırakılacaktır.",
  "Tüm hoparlörler hat trafolu, harici hoparlörler hava basınçlı tip olacaktır.",
  "Yangın ihbar, TV dağıtım, Müzik yayın  sisteminde imalatçı firmanın uygun görüşü alındıktan sonra kablolama yapılacaktır.",
  "UPS-T Panosu yanmaz PVC ve dış kapağı tamamen şeffaf olacak EXIT yönlendirme armatürleri  koridorun  en uzak noktasından görülecek şekilde yerleştirilecektir.",
  "Eğer bir kit kullanılıyorsa armatürün besleme fazı ile sinyal fazı aynı olacaktır.",
  "Parantez içindeki değerler doğrusal olarak azami 4m. uzunluğa kadar döşenen borulardır.",
  "Bir boru içinden 5 yada 6 iletken geçmesi durumunda , çizelgede  4 iletken için verilen borunun yarı çapının bir üst değeri alınacaktır.",
  "Çıplak iletkenler için bir alt boru çapı kullanılacaktır.",
  "Çizelge her çeşit boru için geçerlidir.",
  "Aydınlatma ve Priz Buatları mutlak suretle AYRI olacak",
  "Buat içlerindeki Kablo Ekleri Porselen veya Sıkıştırmalı Tip KLEMENSLERLE yapılacak",
];

/**
 * Default notlar dokümanını DXF entity dizisi olarak üretir.
 * Title + numaralı maddeler tek bir MTEXT entity içinde \P satır kırılımıyla.
 * @param {object} [opts] - { title, notes } override (active template için)
 */
export const createNotlar = (opts) => {
  const title = opts?.title || DEFAULT_TITLE;
  const notes = Array.isArray(opts?.notes) && opts.notes.length > 0
    ? opts.notes
    : DEFAULT_NOTES.map(t => ({ text: t }));

  const items = [];
  if (title) items.push(title);
  notes.forEach((n, i) => {
    const t = typeof n === 'string' ? n : (n?.text || '');
    if (t.trim()) items.push(`${i + 1}- ${t.trim()}`);
  });

  // Tek MTEXT entity'sinde \P paragraf kırılımlarıyla
  const mtextContent = '{\\fTimes New Roman|b0|i0|c162|p18;\\C0;' + items.join('\\P') + '}';

  const result = [
    {
      type: 'LINE',
      vertices: [
        { x: 0,    y: 1500, z: 0 },
        { x: 1000, y: 1500, z: 0 },
      ],
      layer: 'Doc_Notlar',
    },
    {
      type: 'MTEXT',
      text: mtextContent,
      position: { x: 0, y: 1499.9, z: 0 },
      height: 16,
      width: 1000,
      attachmentPoint: 1,    // top-left
      drawingDirection: 5,
      layer: 'Doc_Notlar',
    },
  ];

  return {
    result,
    width: 1000 * Scl,
    height: 1500 * Scl,
  };
};
